import { QueryResult, QueryConfig } from "@/shared/types/base";
import { sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";
import { Vendedor } from "@/shared/types/vendedor";

export async function checkVendedor(numDocumento: string): Promise<Vendedor | null> {
    await sleep(1000);
    const { data } = await api.get("vendedores/check/" + numDocumento);
    return data ? data : null;
}

export function useCheckVendedorQuery(numDocumento: string, queryConfig: QueryConfig<Vendedor | null> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await checkVendedor(numDocumento),
        queryKey: ["vendedores", "check", numDocumento],
    })
}

export interface CheckVendedorQueryProps {
    numDocumento: string,
    queryConfig?: QueryConfig<Vendedor | null>,
    children?: (queryResult: QueryResult<Vendedor | null>) => ReactNode
}

export function CheckVendedorQuery({
    numDocumento,
    children,
    queryConfig
}: CheckVendedorQueryProps) {
    const queryResult = useCheckVendedorQuery(numDocumento, queryConfig);
    return children && children(queryResult);
}